<template>
  <component
    :is="tag"
    :class="lazyClass"
    ref="rootEl"
  >
    <slot v-if="isActive" />
  </component>
</template>

<script lang="ts">
  import {intersectionService} from '@/bps/utilities/js/intersectionService/intersectionService';

  intersectionService.createObserver('lazyload', {rootMargin: '300px'});

  window.addEventListener('hashchange', () => {
    intersectionService.disable();

    setTimeout(() => {
      intersectionService.enable();
      intersectionService.activateAll('lazyload');
    }, 1000);

    // scroll to hash
    setTimeout(() => {
      const hash = window.location.hash;
      if (!hash) {
        return;
      }
      const targetElement = document.querySelector(hash);
      if (targetElement) {
        targetElement.scrollIntoView({behavior: 'smooth'});
      }
    }, 2000);
  });
</script>

<script setup lang="ts">
  import {ref, computed, onMounted, useTemplateRef} from 'vue';

  const props = defineProps<{
    tag?: string;
    className?: string;
  }>();
  const emit = defineEmits<{
    (e: 'loaded', el: Element): void;
  }>();

  const tag = props.tag ?? 'DIV';
  const className = props.className || null;
  const rootEl = useTemplateRef<HTMLElement>('rootEl');

  const isActive = ref(false);

  function onIntersection(element: Element) {
    isActive.value = true;
    emit('loaded', element);
    // info: this triggers mounted() on child components
  }

  const lazyClass = computed(() => (!isActive.value ? 'lazy-load' : className));

  onMounted(() => {
    intersectionService.observeElement('lazyload', rootEl.value, onIntersection);
  });
</script>
